import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../constants/common'
import { useNotification } from '../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../utils/api'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { toUserSelectItemsWithoutStatus, UserMultiSelect } from '../../../User'
import { getEmailAvailableUserProfiles } from '../../Email.api'
import { EmailCopyToEntityFilterModal } from '../EmailCopyToEntityFilterModal'
import { EMAIL_COPY_TO_ENTITY_MODAL_FIELD_NAME_USER } from '../EmailCopyToEntityModal.constants'
import { getEmailCopyToModalFilterPayload } from '../EmailCopyToEntityModal.utils'

import * as styles from './EmailCopyToEntityModalFields.module.css'

import FilterIcon from '../../../../icons/filter-settings.svg'

function EmailCopyToEntityModalFields({
  isLoading,
  setModal,
  onClose,
  onUpdateAvailableUserProfiles,
}) {
  const { t } = useTranslation()

  const { isSubmitting, setValues } = useFormikContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  function handleOpenFilterModal() {
    setModal(
      <EmailCopyToEntityFilterModal
        onClose={onClose}
        onSubmit={handleFilterSubmit}
      />
    )
  }

  function handleFilterSubmit({ values }) {
    onUpdateAvailableUserProfiles({
      setValues,
      values: getEmailCopyToModalFilterPayload(values),
    })
      .then(() => {
        handleAddSuccessNotification(
          'Notification.EmailCopyToEntityFilterAppliedKey'
        )
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        onClose()
      })
  }

  return (
    <FormFieldsContainer className={styles.container}>
      <Button.Outlined
        isGrey
        beforeIconProps={{ Icon: FilterIcon }}
        disabled={isSubmitting}
        height={BUTTON_HEIGHT_32}
        text={t('Email.EmailCopyToEntityModalFilterBtnKey')}
        onClick={handleOpenFilterModal}
      />
      <FormikField
        multi
        Component={FormFieldSelectNG}
        Field={FieldStackedLabel}
        Select={UserMultiSelect}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t('Email.CopyToEntityModalPlaceholderKey'),
            },
          },
        }}
        disabled={isSubmitting}
        emptyValue={EMPTY_LIST}
        fieldComponentProps={{
          isLoading,
          label: t('Email.CopyToEntityModalFieldLabelKey'),
        }}
        getData={getEmailAvailableUserProfiles}
        getDataItems={getItemsFromIdwellApiResponse}
        getErrorProps={getFormikFormFieldErrorProps}
        name={EMAIL_COPY_TO_ENTITY_MODAL_FIELD_NAME_USER}
        toPreparedItems={toUserSelectItemsWithoutStatus}
      />
    </FormFieldsContainer>
  )
}

export default EmailCopyToEntityModalFields
